export default __webpack_public_path__ + "static/media/descricao2.79d10182.png";